/**
 * Handles showing and hiding parts in response to Conditional Logic triggers.
 * 
 * @package Ninja Forms Front-End
 * @subpackage Main App
 * @copyright (c) 2016 WP Ninjas
 * @since 3.0
 */
define( 'controllers/conditionalLogic',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			nfRadio.channel( 'condition:trigger' ).reply( 'show_part', this.showPart, this );
			nfRadio.channel( 'condition:trigger' ).reply( 'hide_part', this.hidePart, this );
			/*
			 * Monotonic counter backing the Multi-Part Reset Flag below. Date.now() has
			 * millisecond resolution, and nested synchronous changePartVisibility() calls
			 * within the same then[] array can complete inside a single millisecond, causing
			 * an inner call to coincidentally match the outer call's flag and reset
			 * alreadyTriggered prematurely (#270). A per-instance counter can never collide.
			 */
			this._mpCallCounter = 0;
		},

		showPart: function( conditionModel, then ) {
			conditionModel.set( 'alreadyTriggered', true );
			this.changePartVisibility( conditionModel, then, true );
			conditionModel.set( 'alreadyTriggered', false );
		},

		hidePart: function( conditionModel, then ) {
			conditionModel.set( 'alreadyTriggered', true );
			this.changePartVisibility( conditionModel, then, false );
			conditionModel.set( 'alreadyTriggered', false );
		},

		changePartVisibility: function( conditionModel, then, visible ) {


            /**
			 * Multi-Part Reset Flag
			 *   Identifies the initial request of a nested loop of conditions
			 *   so that the alreadyTriggered flags can be cleared.
             */
			var mpResetFlag = ++this._mpCallCounter;
			if( ! conditionModel.collection.mpResetFlag ){
                conditionModel.collection.mpResetFlag = mpResetFlag;
			}

			var partCollection = conditionModel.collection.formModel.get( 'formContentData' );
			var partModel = partCollection.findWhere( { key: then.key } );
			partModel.set( 'visible', visible );

			/*
			 * Field keys this part's own showFields()/hideFields() (triggered by the
			 * set('visible', ...) above, via partModel.changeVisible()) just forced to
			 * visible:true or visible:false, bypassing each field's own Conditional
			 * Logic status. Only conditions that reference one of these fields need
			 * re-checking below.
			 */
			var partFieldKeys = partModel.getFieldKeys ? partModel.getFieldKeys() : [];

			/*
			 * Check our conditions again because we have just shown/hidden a part that
			 * could have conditions on it — scoped to conditions that actually reference
			 * a field inside this part (see partFieldKeys above), not the whole form.
			 *
			 * This scoping matters beyond efficiency: a condition unrelated to this part
			 * (e.g. one watching a field in a different part entirely) can have a stale
			 * cached `when` status at this exact moment. Backbone dispatches every
			 * listener for a field's change:value synchronously, in registration order —
			 * if THIS cascade was itself triggered by that same change:value event, an
			 * unrelated condition on the same field may not have run its own status
			 * recompute yet, so calling its checkWhen() here would act on stale data and
			 * can fire its then/else actions out of order (#270). Restricting to
			 * conditions tied to fields actually inside this part avoids ever touching
			 * those unrelated conditions from here at all.
			 */
			conditionModel.collection.each( function( model ) {
				// Avoid triggering a model's own conditions.
				if( model == conditionModel ) return;
				// Avoid re-triggering conditions, which may cause an infinite loop.
				if( model.get( 'alreadyTriggered' ) ) return;
				// Skip conditions that don't reference any field inside this part.
				var whenKeys = model.get( 'when' ) ? model.get( 'when' ).pluck( 'key' ) : [];
				if ( ! _.intersection( whenKeys, partFieldKeys ).length ) return;
				// Trigger conditions.
                model.checkWhen();
                // Set a flag to avoid re-triggering these conditions.
                model.set( 'alreadyTriggered', true );
			} );

            /**
			 * Reset Flag Check
			 *   If is the initial request of the nested loop of conditions
			 *   then clear the previously set alreadyTriggered flags.
             */
			if( mpResetFlag == conditionModel.collection.mpResetFlag ){
				// Clear all alreadyTriggered flags.
                conditionModel.collection.invoke( 'set', { 'alreadyTriggered': false } );
                // Clear the Reset Flag.
                conditionModel.collection.mpResetFlag = false;
			}
		}
	});

	return controller;
} );

